import { VATRate } from 'payment-common/src/vtj/vat-rate.type'

const hasFractions = (value: number): boolean => value % 1 !== 0
const toEuros = (euroCents: number): number => euroCents / 100

const fractionDigitsForEuroCents = 2

export const formatEuroCentsIntoEurWithFixedDecimals = (
  euroCents: number
): string => {
  return (euroCents / 100).toFixed(2)
}

export const formatEuroCentsIntoEurWithCommaFixedDecimalsIfNeeded = (
  euroCents: number
): string => {
  const euros = toEuros(euroCents)
  return hasFractions(euros)
    ? euros.toFixed(fractionDigitsForEuroCents).replace('.', ',')
    : euros.toString()
}

export const vatRateToTaxPercent = (vatRate: VATRate): number => {
  switch (vatRate) {
    case VATRate.NO_TAX:
    case VATRate.VAT_0:
      return 0
    default:
      // This check makes the typescript build fail if a new VATRate is added without handling it here
      const exhaustiveCheck: never = vatRate
      throw new Error(`Unhandled vat rate case: ${exhaustiveCheck}`)
  }
}
